import moment from 'moment';
import React, { useEffect, useState, useRef, useLayoutEffect } from 'react';
import "react-datepicker/dist/react-datepicker.css";
import { useAppSelector, useAppDispatch } from '../../app/hooks';
import {
    getTimeEntryPeriodListAsync, updateTimesheetPeriodSelection, updateTimesheetPeriodBulkSelection,
    UpdateTimesheetPeriodListForPeriodStatusAsync, updateCurrentDate, setTimeSheetPeriodIdsState,
    setAllTimeSheetPeriodIdsState, SendToXero, resetSelectedRecordObjectInState, updateIsLoading,
    getTimesheetPriod
} from './timesheetSlice';
import { setTimesheetStatus, getTimeFromDecimal } from '../../common/timesheetFunction';
import { resetAttachmentList } from '../../features/attachment/AttachmentSlice';
import { updatePageIdState, getPagePermissionsAsync, updateGoogleCalendarTimesheetManualSync, updateOutlookCalendarTimesheetManualSync } from '../../common/GlobalSlice';
import TaskOffCanvas from '../../common/OffCanvas';
import clsx from 'clsx';
import TimesheetPeriodFilters from './TimesheetPeriodFilters';
import GetAttachments from '../../features/attachment/AttachmentItem';
import { KTSVG, KTIcon } from '../../_metronic/helpers';
import { useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import DocumentTitle from '../../common/DocumentTitle';
import Loader from '../../common/Loader';
import fetchAPI from '../../common/fetchAPI';
import { sendToGoogleCalendarAsync, sendToOutlookCalendarAsync } from '../admin/integrations/IntegrationSlice';
import { formatDateWithDateAndMonthName, formatDateWithTZ, FormatInvoiceDecimalNumber, getValueFromResource } from '../../common/timeLiveFunction';
import { ShowToast } from "../../common/Toastr";
import { ShowSwalForCanvas, ShowSwalWithConfirmation } from '../../common/SweetAlert';
// import { SendToXero } from '../billing/invoiceBillingSlice';

const TimesheetPeriodList = () => {
    DocumentTitle("Timesheet Period List");
    const dispatch = useAppDispatch();
    const [selected, setSelected] = useState(false);
    const { t } = useTranslation();
    const location = useLocation();
    const { timeSheetPeriodList, isLoading, timeSheetPeriodIds, isAllChecked, showClockStartEnd: timesheetShowClockStartEnd, decimalFormat } = useAppSelector((state) => state.timesheet);
    const { cultureInfoName, menuList, IsEdit, timeZoneId, isGoogleCalendarTimesheetManualSync, isOutlookCalendarTimesheetManualSync, showClockStartEnd: globalStateShowClockStartEnd, showClockStartEndBy, decimalPlaces, ProfileTimeZoneIANA } = useAppSelector((state) => state.globalState);
    const params = new URLSearchParams(location.search);
    const encoded = params.get("data");
    const parsedState = React.useMemo(() => {
        const encoded = params.get("data");
        return encoded ? JSON.parse(decodeURIComponent(encoded)) : {};
    }, [encoded]);
    const { widgetFilters = null, fromDashboard = false, status = null } = parsedState;
    // const { widgetFilters, fromDashboard } = location.state || {};

    let shouldShowClockStartEnd = false;
    if (showClockStartEndBy === "Account" && globalStateShowClockStartEnd === true) {
        shouldShowClockStartEnd = true;
    } else if (showClockStartEndBy === "Employee" && timesheetShowClockStartEnd === true) {
        shouldShowClockStartEnd = true;
    }

    // Xero work commet
    // const { isLoading: isLoading_integration } = useAppSelector((state) => state.integration);
    const modalAttachmentRef = useRef<any>(null);
    const pageId: string = '18';
    const navigate = useNavigate();
    let isXeroConnected = localStorage.getItem('isXeroConnected');
    const AccountEmployeeId = localStorage.getItem('accountEmployeeId');
    // Xero work commet
    // const [xeroAccessToken,setXeroAccessToken] = useState<string>('');
    // const [xeroTenantId,setXeroTenantId] = useState<string>('');
    // const [xeroIsVisible,setXeroIsVisible] = useState<boolean>(false);

    useEffect(() => {
        if (fromDashboard) {
            const startDate = widgetFilters?.DateRange?.startDate ? widgetFilters.DateRange.startDate : moment().subtract(3, 'months').format('YYYY-MM-DD')
            const endDate = widgetFilters?.DateRange?.endDate ? widgetFilters.DateRange.endDate : moment().format('YYYY-MM-DD');
            const payload = {
                EmployeeId: widgetFilters?.AccountEmployeeId?.[0] ?? AccountEmployeeId,
                StartDate: startDate,
                EndDate: endDate,
            };
            dispatch(getTimesheetPriod(payload));
            getIntegrationAsync("Google", "3B00775F-9B50-4A7D-926F-1192E2E3033E");
            getIntegrationAsync("Outlook", "6E0E6A9C-7A37-4BDA-8D6A-D7D61F00B828");
        }
    }, [fromDashboard])

    useLayoutEffect(() => {
        const fetchPagePermissions = async () => {
            if (pageId && pageId !== '') {
                const res = await dispatch(getPagePermissionsAsync(pageId));
                if (!res.payload.IsList) {
                    navigate('../error/403');
                }
            }
        }
        fetchPagePermissions();
    }, [dispatch, location.pathname, menuList, navigate, pageId]);

    useEffect(() => {
        if (!fromDashboard) {
            dispatch(getTimeEntryPeriodListAsync());
            //getIntegrationAsync();
            getIntegrationAsync("Google", "3B00775F-9B50-4A7D-926F-1192E2E3033E");
            getIntegrationAsync("Outlook", "6E0E6A9C-7A37-4BDA-8D6A-D7D61F00B828");
            // Xero work commet
            // initXero();
        }
    }, []);



    const getIntegrationAsync = async (type: "Google" | "Outlook", systemIntegrationId: string) => {
        const response = await fetchAPI(`api/V2/Integrations/Integration/${type}/${systemIntegrationId}`, "GET", "", true, "");
        const json = await response.json();

        if (type === "Google") {
            dispatch(updateGoogleCalendarTimesheetManualSync(json.IsTimeSheetManual));
        } else {
            dispatch(updateOutlookCalendarTimesheetManualSync(json.IsTimeSheetManual));
        }
    };

    // const getIntegrationAsync = async () => {
    //     const response = await fetchAPI("api/V2/Integrations/Integration", "GET", "", true, "");
    //     const json = await response.json();
    //     dispatch(updateGoogleCalendarTimesheetManualSync(json.IsTimeSheetManual));
    // }

    // Xero work commet
    // const initXero = () =>{
    //     const storedXeroObject = localStorage.getItem('Xero');
    //     const XeroData = (storedXeroObject && storedXeroObject !== 'undefined') ? JSON.parse(storedXeroObject) : null;
    //     if(XeroData){
    //         let base64String = "";
    //         let jsonString = "";
    //         let jsonObject = "";
    //         let javaobject = null;
    //         base64String = XeroData;
    //         jsonString = atob(base64String);
    //         jsonObject = JSON.parse(jsonString);            
    //         javaobject = JSON.parse(jsonObject);
    //         if(javaobject.access_token){
    //             if(javaobject.tenants.length > 0){
    //                 setXeroAccessToken(javaobject.access_token);
    //                 setXeroTenantId((javaobject && javaobject.tenants && javaobject.tenants.length > 0) ? javaobject.tenants[0].tenantId : '');
    //                 setXeroIsVisible(true);
    //             }
    //         }
    //     }
    // }

    const generalObject = {
        "name":
            // t("Filters"),
            getValueFromResource('Filters', dispatch, t),
        "width": "550px",
        "componentName": <TimesheetPeriodFilters />
    }

    //Attachment Work
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [getAccountEmployeeTimeEntryPeriodId, setAccountEmployeeTimeEntryPeriodId] = useState('');
    useEffect(() => {
        if (modalIsOpen) {
            if (modalAttachmentRef.current) {
                modalAttachmentRef.current.click();
            }
        }
    }, [modalIsOpen]);
    const handleAttachment = (accountEmployeeTimeEntryPeriodId: any) => {
        setAccountEmployeeTimeEntryPeriodId(accountEmployeeTimeEntryPeriodId);
        dispatch(resetAttachmentList());
        setModalIsOpen(true);
    }

    //Attachment Work
    //Close Due To Generic Work Start
    // const checkboxChangeHandler = (data: any, accountEmployeeTimeEntryPeriodId: string) => {
    //     dispatch(updateTimesheetPeriodSelection({ "isSelected": data.target.checked, "id": accountEmployeeTimeEntryPeriodId }))
    // }

    // const selectUnselectBulkRecord = (data: any) => {
    //     setSelected(data.target.checked);
    //     dispatch(updateTimesheetPeriodBulkSelection(data.target.checked))
    // }

    // const unSubmittedTimesheet = () => {
    //     let tempArray: any[] = [];
    //     timeSheetPeriodList.map((item: any) => {
    //         if (item.isSelected) {
    //             tempArray.push(item.AccountEmployeeTimeEntryPeriodId, item.AccountId, item.AccountEmployeeId, moment(item.TimeEntryStartDate).format('DD-MMM-YYYY'), moment(item.TimeEntryStartDate).format('DD-MMM-YYYY'), item.TimeEntryViewType);
    //         }
    //     });
    //     tempArray.length > 0 && dispatch(UpdateTimesheetPeriodListForPeriodStatusAsync({ "data": tempArray, "status": 0 }));
    // }

    // const submittedTimesheet = () => {
    //     let tempArray: any[] = [];
    //     timeSheetPeriodList.map((item: any) => {
    //         if (item.isSelected) {
    //             tempArray.push(item.AccountEmployeeTimeEntryPeriodId, item.AccountId, item.AccountEmployeeId, moment(item.TimeEntryStartDate).format('DD-MMM-YYYY'), moment(item.TimeEntryStartDate).format('DD-MMM-YYYY'), item.TimeEntryViewType);
    //         }
    //     });
    //     tempArray.length > 0 && dispatch(UpdateTimesheetPeriodListForPeriodStatusAsync({ "data": tempArray, "status": 1 }))
    // }

    // const handleAllGoogleCalendarCheckboxChange = (e: any) => {
    //     let isChecked = e.target.checked;
    //     dispatch(setAllTimeSheetPeriodIdsState(isChecked))
    // }

    // const handleAllXeroCheckboxChange = (e: any) => {
    //     let isChecked = e.target.checked;
    //     dispatch(setAllTimeSheetPeriodIdsState(isChecked))
    // }

    // const handleXeroCheckboxChange = (e: any, AccountEmployeeTimeEntryPeriodId: any) => {
    //     let isChecked = e.target.checked;
    //     dispatch(setTimeSheetPeriodIdsState({ AccountEmployeeTimeEntryPeriodId, isChecked }))
    // }
    //Close Due To Generic Work End

    const openTimesheetHandler = (date: any) => {
        dispatch(updateCurrentDate({ "date": moment(date).format("YYYY-MM-DD"), "mode": 'current' }));
        navigate('/timesheet');
    }

    const sendToXero = () => {
        if (timeSheetPeriodIds.length === 0) {
            ShowSwalForCanvas('Xero Integration', 'Please select at least one record before sending to Xero.', 'warning');
            return;
        }
        ShowSwalWithConfirmation("Confirmation Required", 'Are you sure you want to send the selected records to Xero?', "Confirm")
            .then((result) => {
                if (result) {
                    let commaSeparatedIds = timeSheetPeriodIds.join(',');
                    let exportType = "TimesheetPeriod";
                    dispatch(SendToXero({ commaSeparatedIds, exportType })).then((result) => {
                        result.payload.StatusCode === "200" ?
                            ShowToast('Success', result.payload.ResponseMessage, "success", "toast-top-right") :
                            ShowToast('Error', result.payload.ResponseMessage, "error", "toast-top-right");
                    }).catch((error) => {
                        dispatch(updateIsLoading(false));
                    });
                }
            })
            .catch((error) => {
                dispatch(updateIsLoading(false));
                ShowToast('Error', 'An unexpected error occurred. Please try again later.', "error", "toast-top-right");
            });
    }



    const sendToGoogleCalendar = async () => {
        if (timeSheetPeriodIds.length === 0) {
            ShowSwalForCanvas('Google Calendar Action', 'Please select at least one record to Google Calendar.', 'warning');
            return;
        }

        ShowSwalWithConfirmation("Confirmation Required", 'Are you sure you want to send the selected records to Google Calendar?', "Confirm")
            .then((result) => {
                if (result) {
                    if (timeSheetPeriodIds.length !== 0) {
                        dispatch(sendToGoogleCalendarAsync({ commaSeparatedIds: timeSheetPeriodIds.join(','), exportType: 'TimesheetPeriod', timeZoneId: timeZoneId })).then((result) => {
                            ShowToast('Success', 'Successfully Integrated.', "success", "toast-top-right");
                            dispatch(resetSelectedRecordObjectInState());
                        });
                    }
                }
            })
            .catch((error) => {
                dispatch(updateIsLoading(false));
                ShowToast('Error', 'An unexpected error occurred. Please try again later.', "error", "toast-top-right");
            });
    };

    const sendToOutlookCalendar = async () => {
        if (timeSheetPeriodIds.length === 0) {
            ShowSwalForCanvas('Outlook Calendar Action', 'Please select at least one record to send to Outlook Calendar.', 'warning');
            return;
        }

        ShowSwalWithConfirmation("Confirmation Required", 'Are you sure you want to send the selected records to Outlook Calendar?', "Confirm")
            .then((result) => {
                if (result) {
                    if (timeSheetPeriodIds.length !== 0) {
                        dispatch(sendToOutlookCalendarAsync({ commaSeparatedIds: timeSheetPeriodIds.join(','), exportType: 'TimesheetPeriod', timeZoneId: timeZoneId })).then((result) => {
                            ShowToast('Success', 'Successfully Integrated.', "success", "toast-top-right");
                            dispatch(resetSelectedRecordObjectInState());
                        });
                    }
                }
            })
            .catch((error) => {
                dispatch(updateIsLoading(false));
                ShowToast('Error', 'An unexpected error occurred. Please try again later.', "error", "toast-top-right");
            });
    };



    const genericCheckboxChangeHandler = (data: any, AccountEmployeeTimeEntryPeriodId: any) => {
        let isChecked = data.target.checked;
        dispatch(setTimeSheetPeriodIdsState({ AccountEmployeeTimeEntryPeriodId, isChecked }));
    }

    const genericSelectUnselectBulkRecord = (e: any) => {
        let isChecked = e.target.checked;
        dispatch(setAllTimeSheetPeriodIdsState(isChecked));
    }

    const unSubmittedTimesheet = () => {
        let tempArray: any[] = [];
        if (timeSheetPeriodIds.length !== 0) {
            timeSheetPeriodIds.map((item) => {
                const tempObject = timeSheetPeriodList.filter(x => x.AccountEmployeeTimeEntryPeriodId === item)[0];
                tempArray.push(tempObject.AccountEmployeeTimeEntryPeriodId, tempObject.AccountId, tempObject.AccountEmployeeId, moment(tempObject.TimeEntryStartDate).format('DD-MMM-YYYY'), moment(tempObject.TimeEntryStartDate).format('DD-MMM-YYYY'), tempObject.TimeEntryViewType);
            });
            dispatch(UpdateTimesheetPeriodListForPeriodStatusAsync({ "data": tempArray, "status": 0 }));
        }
    }

    const submittedTimesheet = () => {
        let tempArray: any[] = [];
        if (timeSheetPeriodIds.length !== 0) {
            timeSheetPeriodIds.map((item) => {
                const tempObject = timeSheetPeriodList.filter(x => x.AccountEmployeeTimeEntryPeriodId === item)[0];
                tempArray.push(tempObject.AccountEmployeeTimeEntryPeriodId, tempObject.AccountId, tempObject.AccountEmployeeId, moment(tempObject.TimeEntryStartDate).format('DD-MMM-YYYY'), moment(tempObject.TimeEntryStartDate).format('DD-MMM-YYYY'), tempObject.TimeEntryViewType);
            });
            dispatch(UpdateTimesheetPeriodListForPeriodStatusAsync({ "data": tempArray, "status": 1 }));
        }
    }

    return (
        <>
            {modalIsOpen && (
                <>
                    <div className='modal drawer-overlay' tabIndex={-1} data-bs-backdrop="false" id='attachmentModel' role="dialog" aria-labelledby="exampleModalSizeSm" aria-hidden="true">
                        {/* <div className="modal fade" tabIndex={-1} id="attachmentModel" data-bs-backdrop="static"> */}
                        <div className="modal-dialog modal-xl">
                            <div className="modal-content rounded">
                                <div className='modal-header pb-2'>
                                    <h5 className='headerTitle'>
                                        {/* {t('Attachment')} */}
                                        {getValueFromResource('Attachment', dispatch, t)}
                                    </h5>
                                    <div className='btn btn-sm btn-icon btn-active-color-primary' data-bs-dismiss='modal' onClick={() => setModalIsOpen(false)}>
                                        <KTIcon iconName='cross' className='fs-1' />
                                    </div>
                                </div>
                                <div className='modal-body pt-0 pb-15 px-5 px-xl-5' style={{ overflowY: 'auto', maxHeight: 'calc(100vh - 300px)' }}>
                                    <GetAttachments Id={getAccountEmployeeTimeEntryPeriodId} AccountAttachmentTypeId={2} IsShowEmployeeInformation={false} />
                                </div>
                                <div className="modal-footer">
                                    <button
                                        type="button"
                                        className="btn btn-secondary btn-bs-btn-font-weight me-2 btn-sm"
                                        data-bs-dismiss="modal"
                                        onClick={() => setModalIsOpen(false)}
                                    >
                                        {/* {t('Cancel')} */}
                                        {getValueFromResource('Cancel', dispatch, t)}

                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <button ref={modalAttachmentRef} type="button" className="btn btn-primary d-none" data-bs-toggle="modal" data-bs-target="#attachmentModel">
                        {/* Launch demo modal */}
                        {getValueFromResource('Launch demo modal', dispatch, t)}
                    </button>
                </>
            )}
            {/* Xero work commet */}
            {/* {(isLoading || isLoading_integration) && <Loader />} */}
            {isLoading && <Loader />}
            <div className="card card-custom admin-card">
                <div className="card-header sticky-top bg-white fixed-top">
                    <h3 className="card-title fw-bold mainHeading">
                        {/* {t('Timesheet Period List')} */}
                        {getValueFromResource('Timesheet Period List', dispatch, t)}
                    </h3>
                    <div className="card-toolbar align-items-center">
                        {isXeroConnected === "true" && timeSheetPeriodList.length > 0 && <>
                            <div className='bullet bg-secondary h-35px w-1px mx-3'></div>
                            <button
                                type="button"
                                className="btn btn-primary btn-bs-btn-font-weight btn-sm"
                                onClick={() => {
                                    sendToXero();
                                }}
                            >
                                {/* {t('Send To Xero')} */}
                                {getValueFromResource('Send To Xero', dispatch, t)}
                            </button>
                            <div className='bullet bg-secondary h-35px w-1px mx-3'></div>
                        </>}
                        {timeSheetPeriodList.length > 0 && <>
                            {(isOutlookCalendarTimesheetManualSync && shouldShowClockStartEnd) && <>
                                <button
                                    type="button"
                                    className="btn btn-primary btn-bs-btn-font-weight btn-sm"
                                    onClick={() => {
                                        sendToOutlookCalendar();
                                    }}
                                >
                                    {/* {t('Send To Google Calendar')} */}
                                    {getValueFromResource('Send To Outlook Calendar', dispatch, t)}
                                </button>
                                <div className='bullet bg-secondary h-35px w-1px mx-3'></div>
                            </>}
                            {(isGoogleCalendarTimesheetManualSync && shouldShowClockStartEnd) && <>
                                <button
                                    type="button"
                                    className="btn btn-success btn-bs-btn-font-weight btn-sm"
                                    onClick={() => {
                                        sendToGoogleCalendar();
                                    }}
                                >
                                    {/* {t('Send To Google Calendar')} */}
                                    {getValueFromResource('Send To Google Calendar', dispatch, t)}
                                </button>
                                <div className='bullet bg-secondary h-35px w-1px mx-3'></div>
                            </>}
                        </>
                        }
                        {IsEdit &&
                            <a onClick={() => { navigate('/timesheet') }}
                                className="btn btn-icon btn-active-light-dark btn-sm ms-0"
                                data-tooltip-id="tooltip-Description"
                                data-tooltip-content=
                                // {t("Add Timesheet")}
                                {getValueFromResource('Add Timesheet', dispatch, t)}
                                data-tooltip-place="bottom">
                                <i className="bi bi-plus fs-3 iconColor"></i>
                            </a>}
                        <a id="kt_OffCanvas"
                            className="btn btn-icon btn-active-light-dark btn-sm ms-0"
                            data-tooltip-id="tooltip-Description"
                            data-tooltip-content=
                            // {t("Filters")}
                            {getValueFromResource('Filters', dispatch, t)}
                            data-tooltip-place="bottom">
                            <i className="bi bi-filter fs-3 iconColor"></i>
                        </a>
                        <div className='bullet bg-secondary h-35px w-1px mx-3'></div>
                        <a onClick={() => { unSubmittedTimesheet() }} className="btn btn-outline btn-sm btn-outline me-0 mb-0 btn-active-light-dark"
                            style={{ fontSize: 13, fontWeight: 600 }}>
                            {/* {t('UnSubmit Timesheet')} */}
                            {getValueFromResource('UnSubmit Timesheet', dispatch, t)}
                        </a>
                        <div className='bullet bg-secondary h-35px w-1px mx-3'></div>
                        <a onClick={() => { submittedTimesheet() }} className="btn btn-outline btn-sm btn-outline me-0 mb-0 btn-active-light-dark"
                            style={{ fontSize: 13, fontWeight: 600 }}>
                            {/* {t('Submit Timesheet')} */}
                            {getValueFromResource('Submit Timesheet', dispatch, t)}
                        </a>
                    </div>
                </div>
                {/* {isLoading ?
                    <div className="app-default" data-kt-app-page-loading-enabled="true" data-kt-app-page-loading="on">
                        <div className="page-loader flex-column bg-dark bg-opacity-25">
                            <span className="spinner-border text-primary" role="status"></span>
                            <span className="text-gray-800 fs-6 fw-semibold mt-5">Loading...</span>
                        </div>
                    </div>
                    : */}
                <div className="card-body">
                    <div className="table-responsive">
                        <table className="table table-row-bordered table-bottom-color align-middle gs-1 gy-1 gx-1">
                            <thead>
                                <tr className="thHeading align-middle">
                                    {/* {isGoogleCalendarTimesheetManualSync &&
                                        <th className='w-25px'>
                                            <div className='form-check form-check-sm form-check-custom form-check-solid small-checkbox'>
                                                <input
                                                    className='form-check-input widget-9-check'
                                                    type='checkbox'
                                                    checked={isAllChecked}
                                                    onChange={(e) => { handleAllGoogleCalendarCheckboxChange(e) }}
                                                />
                                            </div>
                                        </th>
                                    }
                                    {isXeroConnected === "true" &&
                                        <th className='w-25px'>
                                            <div className='form-check form-check-sm form-check-custom form-check-solid small-checkbox'>
                                                <input
                                                    className='form-check-input widget-9-check'
                                                    type='checkbox'
                                                    checked={isAllChecked}
                                                    onChange={(e) => { handleAllXeroCheckboxChange(e) }}
                                                />
                                            </div>
                                        </th>
                                    }
                                    <th className='w-25px'>
                                        <div className='form-check form-check-sm form-check-custom form-check-solid small-checkbox' >
                                            <input
                                                className='form-check-input'
                                                type='checkbox'
                                                checked={selected}
                                                onChange={(e) => { selectUnselectBulkRecord(e) }}
                                            />
                                        </div>
                                    </th> */}
                                    <th className='w-25px'>
                                        <div className='form-check form-check-sm form-check-custom form-check-solid small-checkbox'>
                                            <input
                                                className='form-check-input'
                                                type='checkbox'
                                                checked={isAllChecked}
                                                onChange={(e) => { genericSelectUnselectBulkRecord(e) }}
                                            />
                                        </div>
                                    </th>

                                    <th className=''>
                                        {/* {t('Employee Name')} */}
                                        {getValueFromResource('Employee Name', dispatch, t)}
                                    </th>
                                    <th className=''>
                                        {/* {t('Status')} */}
                                        {getValueFromResource('Status', dispatch, t)}
                                    </th>
                                    <th className=''>
                                        {/* {t('Period Date')} */}
                                        {getValueFromResource('Period Date', dispatch, t)}
                                    </th>
                                    <th className=''>
                                        {/* {t('Period Type')} */}
                                        {getValueFromResource('Period Type', dispatch, t)}
                                    </th>
                                    <th className=''>
                                        {/* {t('Duration')} */}
                                        {getValueFromResource('Duration', dispatch, t)}
                                    </th>
                                    <th className=''>
                                        {/* {t('Hours')} */}
                                        {getValueFromResource('Hours', dispatch, t)}
                                    </th>
                                    <th className=''>
                                        {/* {t('Submitted On')} */}
                                        {getValueFromResource('Submitted On', dispatch, t)}
                                    </th>
                                    <th className=''>
                                        {/* {t('Approved On')} */}
                                        {getValueFromResource('Approved On', dispatch, t)}
                                    </th>
                                    <th className=''>
                                        {/* {t('Rejected On')} */}
                                        {getValueFromResource('Rejected On', dispatch, t)}
                                    </th>
                                    <th className=''>
                                        {/* {t('Entered')} */}
                                        {getValueFromResource('Entered', dispatch, t)}
                                    </th>
                                    {IsEdit && <th className=''>
                                        {/* {t('Open')} */}
                                        {getValueFromResource('Open', dispatch, t)}
                                    </th>}
                                </tr>
                            </thead>
                            <tbody>
                                {timeSheetPeriodList.length > 0 && timeSheetPeriodList.map((item: any, i: any) => (
                                    <tr key={i}>

                                        {/* {isGoogleCalendarTimesheetManualSync &&
                                            <td>
                                                <div className='form-check form-check-sm form-check-custom form-check-solid small-checkbox'>
                                                    <input
                                                        className='form-check-input widget-9-check'
                                                        type='checkbox'
                                                        checked={timeSheetPeriodIds.includes(item.AccountEmployeeTimeEntryPeriodId)}
                                                        onChange={(e) => { handleXeroCheckboxChange(e, item.AccountEmployeeTimeEntryPeriodId) }}
                                                    />
                                                </div>
                                            </td>
                                        }
                                        {isXeroConnected === "true" &&
                                            <td>
                                                <div className='form-check form-check-sm form-check-custom form-check-solid small-checkbox'>
                                                    <input
                                                        className='form-check-input widget-9-check'
                                                        type='checkbox'
                                                        checked={timeSheetPeriodIds.includes(item.AccountEmployeeTimeEntryPeriodId)}
                                                        onChange={(e) => { handleXeroCheckboxChange(e, item.AccountEmployeeTimeEntryPeriodId) }}
                                                    />
                                                </div>
                                            </td>
                                        }
                                        <td>
                                            <div className='form-check form-check-sm form-check-custom form-check-solid small-checkbox'>
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input widget-9-check"
                                                    checked={item.isSelected ? true : false}
                                                    onChange={(e) => { checkboxChangeHandler(e, item.AccountEmployeeTimeEntryPeriodId) }}
                                                />
                                            </div>
                                        </td> */}

                                        <td>
                                            <div className='form-check form-check-sm form-check-custom form-check-solid small-checkbox'>
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input widget-9-check"
                                                    checked={timeSheetPeriodIds.includes(item.AccountEmployeeTimeEntryPeriodId)}
                                                    onChange={(e) => { genericCheckboxChangeHandler(e, item.AccountEmployeeTimeEntryPeriodId) }}
                                                />
                                            </div>
                                        </td>
                                        <td>
                                            <span className="text-gray-800 d-block ">{item.EmployeeName}</span>
                                        </td>
                                        <td>
                                            <span className={clsx('app-navbar-item badge', setTimesheetStatus(item.Approved, item.Rejected, item.Submitted).class)} style={{ width: '60%', fontWeight: '600', lineHeight: '1.2', justifyContent: 'center' }}>
                                                {`${setTimesheetStatus(item.Approved, item.Rejected, item.Submitted).text}`}</span>
                                        </td>
                                        <td>
                                            <a className='text-dark fw-bold d-block'>
                                                {/* <i className="ki-outline ki-calendar-2 fs-5 text-dark"></i> {`${moment.parseZone(item.TimeEntryStartDate).format('DD MMM yy')} - ${moment.parseZone(item.TimeEntryEndDate).format('DD MMM yy')}`} */}
                                                <i className="ki-outline ki-calendar-2 fs-5 text-dark"></i>
                                                {/* {`${moment.parseZone(item.TimeEntryStartDate).format('MMM DD, YYYY')} - ${moment.parseZone(item.TimeEntryEndDate).format('MMM DD, YYYY')}`} */}
                                                {formatDateWithDateAndMonthName(item.TimeEntryStartDate, cultureInfoName.toString())} - {formatDateWithDateAndMonthName(item.TimeEntryEndDate, cultureInfoName.toString())}
                                            </a>
                                            <span style={{ color: '#c5c6c7', fontSize: 12 }}>
                                                {/* {`Start Date - End Date`} */}
                                                {getValueFromResource('Start Date - End Date', dispatch, t)}
                                            </span>
                                        </td>
                                        <td>
                                            <span className="text-gray-800 d-block">
                                                {item.TimeEntryViewType}
                                            </span>
                                        </td>
                                        <td>
                                            <span className="text-gray-800 d-block">
                                                {getTimeFromDecimal(item.TotalHours, false)}
                                            </span>
                                        </td>
                                        <td>
                                            <span className="text-gray-800 d-block">
                                                {decimalFormat ? FormatInvoiceDecimalNumber(cultureInfoName.toString(), Number(item.TotalHours), 2) : item.TotalHours}
                                            </span>
                                        </td>
                                        <td>
                                            <span className="text-gray-800 d-block">
                                                {/* {item.SubmittedDate != null && `${moment(item.SubmittedDate).format('DD MMM yy')}`} */}
                                                {item.SubmittedDate != null && `${
                                                    // formatDateWithDateAndMonthName(item.SubmittedDate, cultureInfoName.toString())
                                                    formatDateWithTZ(moment.parseZone(item.SubmittedDate).format("YYYY-MM-DD"), cultureInfoName.toString(), ProfileTimeZoneIANA)
                                                    }`}
                                            </span>
                                        </td>
                                        <td>
                                            <span className="text-gray-800 d-block">
                                                {item.ApprovedOn != null && `${
                                                    // formatDateWithDateAndMonthName(item.ApprovedOn, cultureInfoName.toString())
                                                    formatDateWithTZ(moment.parseZone(item.ApprovedOn).format("YYYY-MM-DD"), cultureInfoName.toString(), ProfileTimeZoneIANA)
                                                    }`}
                                            </span>
                                        </td>
                                        <td>
                                            <span className="text-gray-800 d-block">
                                                {item.RejectedOn != null && `${
                                                    // formatDateWithDateAndMonthName(item.RejectedOn, cultureInfoName.toString())
                                                    formatDateWithTZ(moment.parseZone(item.RejectedOn).format("YYYY-MM-DD"), cultureInfoName.toString(), ProfileTimeZoneIANA)
                                                    }`}
                                            </span>
                                        </td>
                                        <td>
                                            <span className="text-gray-800 d-block">
                                                {item.IsEntered}
                                            </span>
                                        </td>
                                        {IsEdit &&
                                            <td>
                                                <span className="text-gray-800 d-block cursor-pointer" onClick={() => { openTimesheetHandler(item.TimeEntryStartDate) }}>
                                                    {/* {'Open'} */}
                                                    {getValueFromResource('Open', dispatch, t)}

                                                </span>
                                            </td>}
                                        <td>
                                            <a className="text-gray-800 d-block cursor-pointer"
                                                style={{ textAlign: 'center' }}
                                                onClick={(event: any) => {
                                                    event.preventDefault();
                                                    handleAttachment(item.AccountEmployeeTimeEntryPeriodId);
                                                }}>
                                                <i className="bi bi-paperclip fs-4 iconColor"></i>
                                            </a>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                        {timeSheetPeriodList.length === 0 &&
                            <div className=''><p className='noDataFound'>
                                {/* {t('No Record Found')} */}
                                {getValueFromResource('No Record Found', dispatch, t)}

                            </p>
                            </div>
                        }
                    </div>
                </div>
                {/* } */}
            </div>
            <TaskOffCanvas obj={generalObject} />
        </>
    )
}

export default TimesheetPeriodList